import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "../../globalStyle/GlobalStyle";
import { StyledForm } from "../Auth.styled";
import AuthLayout from "../../layout/AuthLayout";
import Logo from "../../assets/fortcore-icon.png";

function ForgotPassword() {
	const [email, setEmail] = useState("");
	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);
	const [currentStep, setCurrentStep] = useState("email");
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const response = await fetch("https://test.fortcoretech.com/api/functions/forgotPassword", {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify({ email }),
			});

			const res = await response.json();
			if (!res.error) {
				toast.success("OTP code has been sent to your mail");
				setCurrentStep("otp");
				// console.log(res);
			} else {
				console.log(res);
				toast.error(res.error);
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			toast.error("Something went wrong. Please try again.");
			setLoading(false);
		}
	};

	const handleVerifyOTP = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			// call API to send OTP to email using fetch
			const response = await fetch("https://test.fortcoretech.com/api/functions/verifyForgotPasswordOtp", {
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify({ email, otp }),
			});

			const res = await response.json();
			if (!res.error) {
				console.log(res);
				toast.success("OTP has been verified successfully");
				// Go to reset password page
				navigate("/reset-password", { state: { email } });
			} else {
				console.log(res);
				toast.error(res.error);
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			toast.error("Something went wrong. Please try again.");
			setLoading(false);
		}
	};

	return (
		<AuthLayout>
			{currentStep === "email" ? (
				<>
					<img className='logo' src={Logo} alt='' />
					<p className='subtext'>Recover Admin Access</p>

					<StyledForm onSubmit={handleSubmit}>
						<label>Email</label>
						<input
							type='email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder='Enter email'
							disabled={loading}
							required
						/>

						<Button type='submit' className='mt-5'>
							{!loading ? "Continue" : <div className='loader'></div>}
						</Button>
					</StyledForm>

					<p className='mt-8'>
						Remember password? <Link to='/login'>Go to login</Link>
					</p>
				</>
			) : (
				<VerifyOTP otp={otp} setOtp={setOtp} loading={loading} handleVerifyOTP={handleVerifyOTP} />
			)}
		</AuthLayout>
	);
}

/* eslint-disable react/prop-types */

const VerifyOTP = ({ otp, setOtp, loading, handleVerifyOTP }) => {
	return (
		<>
			<img className='logo' src={Logo} alt='' />
			<p className='subtext'>Verify OTP</p>

			<StyledForm onSubmit={handleVerifyOTP}>
				<p className='text-center mb-10'>Enter OTP sent to your email address</p>

				<input
					id='otp_input'
					type='number'
					value={otp}
					onChange={(e) => setOtp(e.target.value)}
					inputMode='numeric'
					placeholder='Enter OTP code'
					disabled={loading}
					required
				/>

				<Button type='submit' className='mt-5'>
					{!loading ? "Verify" : <div className='loader'></div>}
				</Button>
			</StyledForm>

			<p className='mt-8'>
				Remember password? <Link to='/login'>Go to login</Link>
			</p>
		</>
	);
};

export default ForgotPassword;
